const helpers = require('./helpers')

const externalSrc = 'https://www.clarity.ms/tag/'

/* 
Original script for reference: 
<script type="text/javascript"> (function(c,l,a,r,i,t,y){ c[a]=c[a]||function(){(c[a].q=c[a].q||[]).push(arguments)}; t=l.createElement(r);t.async=1;t.src="https://www.clarity.ms/tag/"+i; y=l.getElementsByTagName(r)[0];y.parentNode.insertBefore(t,y); })(window, document, "clarity", "script", "cfzrze21t6"); </script>
*/

module.exports.setUpClarityScripts = function (clarityId) {
  if (helpers.hasScriptAlreadyLoaded(externalSrc)) {
    return
  }
  window.clarity =
    window.clarity ||
    function () {
      ;(window.clarity.q = window.clarity.q || []).push(arguments)
    }
  const clarityScript = document.createElement('script')
  clarityScript.async = 1
  clarityScript.src = externalSrc + clarityId
  const firstScript = document.getElementsByTagName('script')[0]
  if (firstScript?.parentNode) {
    firstScript.parentNode.insertBefore(clarityScript, firstScript)
  } else {
    document.head.appendChild(clarityScript)
  }
}
